import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.div`
  display: flex;
  align-items: center;
  margin-left: 5px;
  height: 100%;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const DivLink = styled(Link)`
  padding: 0px 3px;
  text-decoration: none;
  cursor: pointer;
  width: 100%;
  font-weight: 700;
  color: #fff;
`;

export const Text = styled.div`
  font-size: 12px;
  margin-bottom: 10px;
  max-width: 300px;

  @media (max-width: 768px) {
    padding: 5px;
    margin-bottom: 0px;
  }
`;
